import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddPhotoAlternate from '@mui/icons-material/AddPhotoAlternate';
import PeaCharacter from './UI/PeaCharacter';

const PlaceholderSource = ({ onClick }) => (
  <div className="empty-state">
    <PeaCharacter className="pea-pod-hero" />
    <Typography component="h3" variant="h4" className="empty-title">
      Add an image
    </Typography>
    <Typography className="empty-description" color="textSecondary">
      Upload an image or GIF to start editing.
    </Typography>
    <div className="upload-prompt">
      <Button
        variant="contained"
        color="primary"
        size="large"
        disableElevation
        startIcon={<AddPhotoAlternate />}
        onClick={onClick}
      >
        Choose an image
      </Button>
      <Typography variant="caption" color="textSecondary">
        JPG, PNG or GIF · Up to 10 MB
      </Typography>
    </div>
  </div>
);

PlaceholderSource.propTypes = { onClick: PropTypes.func };

export default PlaceholderSource;
